import React, { useState } from 'react';
import { InfoCard, Link } from '@backstage/core-components';
import { catalogApiRef, useEntity } from '@backstage/plugin-catalog-react';
import { useApi } from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';
import { ANNOTATION_EDIT_URL, UserEntity } from '@backstage/catalog-model';
import { Box, Grid, IconButton, Typography } from '@material-ui/core';
import { MemberComponent } from '../MembersListCard';
import EditIcon from '@material-ui/icons/Edit';

export const LeaderCard = () => {
  const { entity } = useEntity();
  const catalogApi = useApi(catalogApiRef);
  const owner = entity?.spec?.owner ? (entity.spec.owner as string) : '';
  const [leaderEntity, setLeaderEntity] = useState<UserEntity>();
  const [leaderTitle, setLeaderTitle] = useState<string>('Leader');
  const entityMetadataEditUrl =
    entity.metadata.annotations?.[ANNOTATION_EDIT_URL];

  useAsync(async () => {
    const membersList = await catalogApi.getEntities({
      filter: [{ kind: ['User'], 'metadata.name': [owner] }],
    });
    const memberListItems = membersList.items?.filter(it => !!it);
    const title = (memberListItems[0]?.spec?.profile as any).title
      ? `Leader - ${(memberListItems[0].spec!.profile as any).title}`
      : 'Leader';
    setLeaderEntity(memberListItems[0] as UserEntity);
    setLeaderTitle(title);
  }, [owner, entity, catalogApi]);

  const infoCardAction = entityMetadataEditUrl ? (
    <IconButton
      aria-label="Edit"
      title="Edit Metadata"
      component={Link}
      to={entityMetadataEditUrl}
    >
      <EditIcon />
    </IconButton>
  ) : (
    <IconButton aria-label="Edit" disabled title="Edit Metadata">
      <EditIcon />
    </IconButton>
  );

  return (
    <InfoCard
      title={leaderTitle}
      variant="gridItem"
      action={<>{infoCardAction}</>}
    >
      <Grid container spacing={3}>
        {leaderEntity ? (
          <MemberComponent
            member={leaderEntity}
            key={leaderEntity.metadata.uid}
            sm={12}
            md={6}
            xl={4}
          />
        ) : (
          <Box p={2}>
            <Typography>This group has no leader.</Typography>
          </Box>
        )}
      </Grid>
    </InfoCard>
  );
};
